import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { Flex, Text, Box, Heading } from 'roo-ui/components';
import { mediaQuery } from 'lib/styledSystem';

export const QuestionText = ({ children, ...rest }) => (
  <StyledQuestionText {...rest} data-testid="question" itemProp="name">
    {children}
  </StyledQuestionText>
);
QuestionText.propTypes = {
  children: PropTypes.node.isRequired,
};

export const QuestionWrapper = ({ children }) => (
  <Flex flexDirection="column" data-testid="question-answer-block" itemScope itemProp="mainEntity" itemType="https://schema.org/Question">
    {children}
  </Flex>
);
QuestionWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export const AnswerWrapper = ({ children }) => (
  <Box data-testid="answer" itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
    <Flex flexDirection="column" data-testid="answer-text" itemProp="text">
      {children}
    </Flex>
  </Box>
);
AnswerWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export const Topic = styled(Box)`
  padding-bottom: ${themeGet('space.4')};
  border-bottom: 2px solid ${(props) => (props.isLast ? 'transparent' : themeGet('colors.greys.alto'))};
`;

export const AnswerText = styled(Text)`
  font-size: ${themeGet('fontSizes.base')};
  margin-bottom: ${themeGet('space.4')};
`;

export const Table = styled(Flex)`
  border: 1px solid ${themeGet('colors.greys.alto')};
  width: fit-content;
`;

export const TableCell = styled(Flex)`
  flex-wrap: wrap;
  justify-content: flex-start;
  border-bottom: ${themeGet('borders.1')} ${(props) => (props.isLast ? 'transparent' : themeGet('colors.greys.alto'))};
  padding: ${themeGet('space.4')};
  height: ${themeGet('space.20')};

  ${mediaQuery.minWidth.sm} {
    height: ${themeGet('space.14')};
    align-items: flex-start;
  }
`;

export const Column = styled(Flex)`
  flex-direction: column;
  border-right: ${themeGet('borders.1')} ${(props) => (props.isRight ? 'transparent' : themeGet('colors.greys.alto'))};

  ${mediaQuery.minWidth.sm} {
    width: ${(props) => (props.isRight ? '300px' : '200px')};
  }
`;

export const Wrapper = styled(Box)`
  border-bottom: 1px solid ${themeGet('colors.greys.alto')};
`;

export const TitleText = styled(Heading.h2)`
  margin-top: ${(props) => (props.isFirst ? themeGet('space.10') : themeGet('space.15'))};
  padding-top: ${themeGet('space.5')};
`;

export const SubTitleText = styled(Heading.h3)`
  margin-top: ${(props) => (props.isFirst ? themeGet('space.5') : themeGet('space.10'))};
`;

const StyledQuestionText = styled(Text)`
  font-size: ${themeGet('fontSizes.md')};
  margin-bottom: ${themeGet('space.3')};
  margin-top: ${themeGet('space.10')};
`;
